import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
};

export const icon: SxStyle = {
  color: (p) => p.palette.grey[400],
  cursor: 'pointer',

  '&:hover': {
    color: (p) => p.palette.grey[800],
  },
};
